import { Props } from './Layout'

export type Params = {
  onClickWait: () => void
  onClickSearch: () => void
}

export const useProps = (params: Params): Props => {
  return { ...params }
}
